/**
 * Abstract Products View
 */
class AbstractProductsView {

	constructor(presenter, cardsWrapperId, cardClassName) {

		this.presenter = presenter;
		this.cardsWrapper = $(cardsWrapperId);
		this.cardsWrapperId = cardsWrapperId;
		this.cardClassName = cardClassName;
		this.nextPage = this.cardsWrapper.attr("data-next-page");
		this.timeout = null;

		/*
		 * Listeners
		 */

		// on the window being resized, check the card heights
		$(window).on("resize", $.proxy(function(_event) {
			this.checkCards();
		}, this));

		// add listeners to any card images loaded into the page
		this.cardsWrapper.find(cardClassName).each($.proxy(function(_event, card) {
			this.addImageListener($(card));
		}, this));

		/*
		 * Initialisation
		 */

		// check the card heights
		this.checkCards();

	}

	/*
	 * Actions
	 */

	addSection(section) {

		// parse the section into a jquery object
		var html = $($.parseHTML(section));

		// get the product cards in the section, and then append them to the product cards wrapper
		html.find(this.cardClassName).each($.proxy(function(_event, card) {
			this.addCard($(card));
		}, this));

		// get the next page from the section
		var page = html.find(this.cardsWrapperId).attr("data-next-page");
		this.nextPage = page;

		// check the card heights
		this.checkCards();

	}

	addCard(card) {
		
		// add the card to the cards wrapper, and make sure we add a listener to its image
		this.cardsWrapper.append(card);
		this.addImageListener(card);

	}

	addImageListener(card) {
		
		// check the card heights when this card's image finishes loading
		card.find("img").on("load", $.proxy(function(_event) {
			this.checkCards();
		}, this)).each(function() {
			// this function catches the instance where the image might be cached
			if (this.complete) { $(this).trigger("load"); }
		});

	}

	checkCards() {

		if (this.timeout != null) { clearTimeout(this.timeout); }
		this.timeout = setTimeout($.proxy(function() {

			// we always update the list of cards, as they can be added dynamically via ajax and javascript
			var cards = $(this.cardClassName);

			// initialise the maximum height, then reset all the cards with a height of auto
			var maxHeight = 0;
			cards.each(function() { $(this).css("height", "auto"); });

			// get the height of each card, and check it against the maximum height
			cards.each(function() {
				var height = $(this).height();
				if (height > maxHeight) { maxHeight = height; }                
			});

			// adjust the height of any card that is less than the maximum height
			cards.each(function() {
				var height = $(this).height();
				if (height < maxHeight) { $(this).height(maxHeight); }                
			});

		}, this), 250);
	
	}

	sort(objects, attribute, direction) {
		
		// compare the provided arrays of objects, based on the value in the provided attribute, then sort by the provided direction
		objects.sort(function(objectA, objectB) {
			var attrA = $(objectA).attr(attribute).toUpperCase();
			var attrB = $(objectB).attr(attribute).toUpperCase();
			if (attrA < attrB) { return direction * -1; }
			if (attrA > attrB) { return direction * 1; }
			return 0;
		});

	}

	/*
	 * Getters and Setters
	 */

	getNextPage() {
		return this.nextPage;
	}
	
}